import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Store
import { actions } from 'core/store'

// Styled Components
import { TableWrapper } from './AdminVasps.elements'

// Views
import { Container } from 'views/components'
import { AdminVaspsTable } from 'views/containers'
import { App, Header, PageWrapper, Sidebar, AdminVaspsSubHeader } from 'views/layouts'

// Hooks
import { useLocalStorage } from 'core/hooks/storage'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions

// !THIS PAGE IS NOT CURRENTLY SECURE
// !ADD RESTRICTIONS TO ROUTING IN THE CORE ROUTING
function AdminVasps() {
  const [userCredentials] = useLocalStorage('userCredentials', {})

  useEffect(() => {
    if (userCredentials?.role_id !== 0 || !userCredentials) {
      window.location.replace(window.location.origin)
    }
  }, [userCredentials])
  return (
    <App>
      <Sidebar />
      <Header pageTitle="Vasp Notification" subHeader={<AdminVaspsSubHeader />} />
      <PageWrapper>
        <Container>
          <TableWrapper>
            <AdminVaspsTable />
          </TableWrapper>
        </Container>
      </PageWrapper>
    </App>
  )
}

// Default Props
AdminVasps.defaultProps = {
  actions: {},
  ui: {},
  filters: {},
}

// Proptypes Validation
AdminVasps.propTypes = {
  actions: PropTypes.shape({
    setActiveModule: PropTypes.func,
    setShowHeaderLoader: PropTypes.func,
  }),
  ui: PropTypes.shape({}),
  filters: PropTypes.shape({}),
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminVasps)
